"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var QueryType;
(function (QueryType) {
    QueryType["sql"] = "sql";
})(QueryType = exports.QueryType || (exports.QueryType = {}));
//# sourceMappingURL=QueryType.js.map